module.exports = __webpack_public_path__ + "static/dmon-003-262096466eb586302e7c32693c20e656.jpg";